import React from 'react';
import AddHouse from 'features/houseInfo/addHouse';
import ShowRoom from 'features/houseInfo/addRooms';
import logo from './logo.jpg';
import './App.css';

export default function App() {
  return (
    <div>
      <img src={logo} />
      <AddHouse />
      <ShowRoom />
    </div>
  );
}